// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3lGOw","footer":"ModalError_footer__2KonU"};